import { combine, sumArray } from '@ms/utils-es/math'

const cr = (list = [], type) => {
  const arr = [...list]
  const len = arr.length
  let m = type

  if (len < m) {
    return 0
  } else if (len <= 1 || m <= 1) {
    return 1
  }

  let total = sumArray(arr)
  let sum = 0
  const count = arr.pop()

  let a = 1
  total -= count
  m--

  if (count > 1) {
    a = m === 1 ? combine(total, 1) : cr(arr, m)
  } else {
    // 数量为 1 的直接用组合公式计算
    a = combine(total, m)
  }

  sum = count * a + cr(arr, type)

  return sum
}

/**
 * 从 [list] 中 选取 [type] 个元素进行组合，无排序，选取的元素互斥, 例 combineMutiple([1, 2, 3, 3], 4)
 * @param  {Array}  list  如 [1, 2, 3, 3]： 元素值为 selection list 中相同 event 计数
 * @param  {Number} type  选取多少个元素
 * @return {Number}       组合值
 */
export const combineMutiple = (list = [], type = 1) => {
  const tmpList = [...list].sort()

  if (type === 1) {
    const total = sumArray(tmpList)
    return combine(total, 1)
  }

  if (type === list.length) {
    return list.reduce((sum, cur) => sum * cur, 1)
  }

  return cr(tmpList, type)
}

// 计算最小 odds 对应组合的总 odds
export const getMinCombineOdds = (oddsList = [], n, maxLimitOdds) => {
  // min
  const minList = oddsList
    .map((x) => {
      if (Array.isArray(x)) {
        return Math.min(...x)
      } else {
        return +x
      }
    })
    .filter((x) => x > 0)
    .sort((a, b) => a - b)

  let min = 1
  // let max = 1
  for (let i = 0; i <= n - 1; i++) {
    min = min * minList[i]

    // 最大 odds
    if (min > maxLimitOdds) {
      min = maxLimitOdds
      break
    }
  }

  return min
}

// 计算当前组合总 odds
export const getCombsOdds = (combStr, oddsList = [], maxLimitOdds, n) => {
  let odds = 1
  // 如果当前位不为 1，表示未选中
  const checkedOddsList = oddsList.filter((_x, i) => combStr[i] === '1')
  const len = checkedOddsList.length
  for (let i = 0; i < len; i++) {
    const item = checkedOddsList[i]
    if (Array.isArray(item)) {
      if (n === 1) {
        odds *= Math.max(...item.map((x) => Number(x)))
      } else {
        odds *= item.reduce((sum, cur) => sum + Number(cur), 0)
      }
      // 冲突selection不做加法 取最大 暂时不改
      // odds *= Math.max(...item.map(x => Number(x)))
    } else {
      odds *= item
    }
    if (maxLimitOdds && odds >= maxLimitOdds) {
      odds = maxLimitOdds
      break
    }
  }
  return odds
}

export const getMaxBetOdds = (oddsList = [], n) => {
  const arr = []
  const len = oddsList.length
  for (let i = 0; i < len; i++) {
    const item = oddsList[i]
    if (Array.isArray(item)) {
      item.sort((a, b) => a - b)
      const max = Number(item[item.length - 1])
      arr.push(max)
    } else {
      arr.push(Number(item))
    }
  }
  arr.sort((a, b) => b - a)
  return arr.splice(0, n).reduce((total, odds) => total * odds, 1)
}

/**
 * 获取最大 odds: 所有组合都中奖, 需要全排列，这里有最大上限 maxLimitOdds
 * 如 ["11100", "11010", "10110", "01110", "11001", "10101", "01101", "10011", "01011", "00111"]
 * '1' 代表当前位被选中，'0' 代表不选
 */
export const getMaxCombineOdds = (oddsList = [], n, maxLimitOdds) => {
  const m = oddsList.length
  let odds = 0
  let str = '1'.repeat(n) + '0'.repeat(m - n)
  odds += getCombsOdds(str, oddsList, maxLimitOdds)

  while (true) {
    if (maxLimitOdds && odds >= maxLimitOdds) {
      odds = maxLimitOdds
      break
    }

    const index = str.indexOf('10')
    if (index === -1) {
      break
    }

    if (str[0] > 0) {
      str = str.replace('10', '01')
      odds += getCombsOdds(str, oddsList, maxLimitOdds, n)
    } else {
      str = str.replace('10', '01')
      const before = str.substring(0, index).split('').reverse().join('')
      const last = str.substring(index)
      str = before + last
      odds += getCombsOdds(str, oddsList, maxLimitOdds, n)
    }
  }
  return odds
}

// 展开生成所有 odds 组合, 例如：["5.20", ["6.80", "13.00"], "4.10", "4.50"]
const flatOddsCombs = (oddsList = []) => {
  const list = [...oddsList].sort((a) => {
    if (Array.isArray(a)) {
      return 1
    }
    return -1
  })
  const arr = []
  const len = list.length
  for (let i = 0; i < len; i++) {
    const item = list[i]
    if (Array.isArray(item)) {
      // copy arr
      const beforeArr = JSON.parse(JSON.stringify(arr))
      item.forEach((x, index) => {
        if (i === 0) {
          if (arr[index]) {
            arr[index].push(x)
          } else {
            arr[index] = [x]
          }
          return
        }
        // beforeArr[index]
        if (index === 0) {
          arr.forEach((_a, k) => {
            arr[k].push(x)
          })
        } else {
          // copy before arr
          const tmpArr = JSON.parse(JSON.stringify(beforeArr))
          tmpArr.forEach((_a, k) => {
            tmpArr[k].push(x)
          })
          arr.push(...tmpArr)
        }
      })
    } else {
      if (arr.length) {
        arr.forEach((_, k) => {
          arr[k].push(item)
        })
      } else {
        arr[0] ? arr[0].push(item) : (arr[0] = [item])
      }
    }
  }
  return arr
}

// 计算当前组合总 bonus
export const getCombsBonus = (combStr, { bankerOdds = 1, validBonusBankerOddsCount = 0, oddsList, maxLimitBonus, qualifyingOddsLimit, bonusRatios, stake = 0 }) => {
  // const arr = []
  oddsList = oddsList.sort((a, b) => a - b)

  // 如果当前位不为 1，表示未选中
  const checkedOddsList = oddsList.filter((_x, i) => combStr[i] === '1')
  const arr = flatOddsCombs(checkedOddsList)
  let sum = 0

  // 遍历全部组合
  for (let i = 0; i < arr.length; i++) {
    // 当前组合
    const combs = arr[i]
    let odds = 1
    // 有效 odds 计数
    let validCount = validBonusBankerOddsCount
    for (let k = 0; k < combs.length; k++) {
      const item = combs[k]
      if (+item >= qualifyingOddsLimit) {
        validCount++
      }
      odds *= +item
    }

    const ratio = (bonusRatios[validCount] || 0) / 100
    if (ratio !== 0) {
      // 有 bonus
      if (ratio) {
        sum += stake * odds * ratio * bankerOdds
      }

      // 达到最大值
      if (maxLimitBonus && sum >= maxLimitBonus) {
        sum = maxLimitBonus
        break
      }
    }
  }

  return sum
}

export const getMaxCombineBonus = (oddsList = [], n, { bankerOdds = [], validBonusBankerOddsCount = 0, maxLimitBonus, qualifyingOddsLimit = 1.2, bonusRatios, stake = 0 }) => {
  if (stake <= 0) return 0

  const m = oddsList.length
  let bonus = 0
  let str = '1'.repeat(n) + '0'.repeat(m - n)
  bonus += getCombsBonus(str, { bankerOdds, validBonusBankerOddsCount, oddsList, maxLimitBonus, qualifyingOddsLimit, bonusRatios, stake })

  while (true) {
    if (maxLimitBonus && bonus >= maxLimitBonus) {
      bonus = maxLimitBonus
      break
    }

    const index = str.indexOf('10')
    if (index === -1) {
      break
    }

    if (str[0] > 0) {
      str = str.replace('10', '01')
      bonus += getCombsBonus(str, { bankerOdds, validBonusBankerOddsCount, oddsList, maxLimitBonus, qualifyingOddsLimit, bonusRatios, stake })
    } else {
      str = str.replace('10', '01')
      const before = str.substring(0, index).split('').reverse().join('')
      const last = str.substring(index)
      str = before + last
      bonus += getCombsBonus(str, { bankerOdds, validBonusBankerOddsCount, oddsList, maxLimitBonus, qualifyingOddsLimit, bonusRatios, stake })
    }
  }
  return bonus
}
